import { useMemo } from "react";
import { waLink } from "../lib/constants";

export const MaintenanceSchedulePanel = ({ buildings = [], jobs = [], waNumber = "" }) => {
  const now = new Date();
  const curTW = Math.floor(now.getMonth() / 3) + 1;
  const curYear = now.getFullYear();

  const serviced = useMemo(() => {
    const set = new Set();
    jobs.forEach((j) => {
      if (Number(j.triwulan) === curTW && Number(j.tahun) === curYear) {
        j.items.forEach((it) => set.add(String(it.gedung || j.title || "").trim()));
      }
    });
    return set;
  }, [jobs, curTW, curYear]);

  const pending = useMemo(
    () => (buildings || []).filter((b) => !serviced.has(String(b.name || "").trim())),
    [buildings, serviced]
  );

  if (!buildings || buildings.length === 0) return null;

  const total = buildings.length;
  const done = total - pending.length;
  const allClear = pending.length === 0;

  const waText =
    `*Pengingat Jadwal Maintenance — Triwulan ${curTW} / ${curYear}*\n\n` +
    (allClear
      ? `Semua ${total} gedung sudah terjadwal/dikerjakan pada triwulan ini. ✅`
      : `Gedung yang BELUM dijadwalkan servis (${pending.length} dari ${total}):\n` +
        pending.map((b, i) => `${i + 1}. ${b.name}`).join("\n"));

  return (
    <section
      className="no-print bg-white rounded-xl border border-slate-200 shadow-sm mb-6 overflow-hidden"
      data-testid="maintenance-schedule-panel"
    >
      <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-slate-200 bg-slate-50/70">
        <div className="flex items-center gap-2 min-w-0">
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-orange-50 text-orange-600 ring-1 ring-orange-200 shrink-0">
            <i className="ph-bold ph-calendar-check text-lg" />
          </span>
          <div className="min-w-0">
            <p className="font-display font-extrabold text-slate-900 text-sm leading-tight truncate">
              Jadwal Maintenance — Triwulan {curTW} / {curYear}
            </p>
            <p className="text-[11px] font-semibold text-slate-500">
              {done}/{total} gedung sudah dijadwalkan triwulan ini
            </p>
          </div>
        </div>
        {waNumber && (
          <a
            href={waLink(waNumber, waText)}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-lg text-xs font-bold shrink-0"
            data-testid="maintenance-wa-btn"
          >
            <i className="ph-bold ph-whatsapp-logo text-base" />
            <span className="hidden sm:inline">Kirim Pengingat</span>
          </a>
        )}
      </div>

      <div className="p-5">
        {allClear ? (
          <div className="flex items-center gap-2 text-sm font-semibold text-emerald-700" data-testid="maintenance-all-clear">
            <i className="ph-bold ph-check-circle text-lg" /> Semua gedung sudah terjadwal / dikerjakan pada triwulan ini.
          </div>
        ) : (
          <>
            <p className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-3">
              Perlu Dijadwalkan ({pending.length})
            </p>
            <div className="flex flex-wrap gap-2" data-testid="maintenance-pending-list">
              {pending.map((b) => (
                <span
                  key={b.id || b.name}
                  className="inline-flex items-center gap-1.5 text-xs font-bold text-rose-700 bg-rose-50 border border-rose-200 px-3 py-1.5 rounded-lg"
                  data-testid={`maintenance-pending-${b.name}`}
                >
                  <i className="ph-bold ph-warning-circle" /> {b.name}
                </span>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};
